import { useInfiniteQuery } from '@tanstack/react-query';
import { Tier } from 'api/generated/graphql';

import { useGraphQLClient } from 'hooks';

const useGetPastTournamentRaces = ({
  allUsers = true,
  queryKey = ['pastTournamentRacesQuery', allUsers],
  startTime,
  endTime,
  tier = [Tier.WeeklyTournament, Tier.Tournament],
}: {
  allUsers?: boolean;
  queryKey?: (string | boolean | Date | undefined)[];
  startTime?: Date;
  endTime?: Date;
  tier?: Tier[];
}) => {
  const { graphQLClient, hasToken, graphql } = useGraphQLClient();

  const pastRacesGql = graphql(`
    query GetPastTournamentRaces(
      $allUsers: Boolean
      $startTime: DateTime
      $endTime: DateTime
      $tier: [tier!]
    ) {
      getPastRaces(
        filter: {
          limit: 50
          allUsers: $allUsers
          startTime: $startTime
          endTime: $endTime
          tier: $tier
        }
      ) {
        id
        laps
        prizePool
        distributionStatus
        status
        userInRace

        createdAt
        executedAt
        tuningPeriodEndTime
        qualifyingAnnouncementTime
        startTime
        numberOfTickets
        timestampWithMcs
        difficulty

        airTemperatureCategory
        tarmacConditionCategory
        trackRoughnessCategory
        trackTemperatureCategory
        weatherCategory
        windCategory
        tier {
          name
        }

        playersParticipants {
          id
          position
          status
          time
          points
          earnings

          car {
            id
            name
            livery
            tyresId
            rarity
            tier {
              name
            }
            tyres {
              id
            }
          }

          user {
            id
            email
            avatarId
            playerName
            countryFlag
          }
        }

        track {
          id
          codeName
          frontendName
          length
          description
          has2D
          has3D
        }
      }
    }
  `);

  const getRacesByUserId = useInfiniteQuery({
    enabled: Boolean(hasToken),
    queryKey: queryKey,
    queryFn: () => {
      return graphQLClient.request(pastRacesGql, {
        allUsers: allUsers,
        startTime: startTime?.toISOString(),
        endTime: endTime?.toISOString(),
        tier: tier,
      });
    },
  });

  return getRacesByUserId;
};

export default useGetPastTournamentRaces;
